<div class="active-profile">
  <cm-profile-avatar class="avatar avatar--big" [imageUrl]="profile.image" [placeholder]="profile.avatarPlaceholder" />
  @if (isLoggedAsProfile) {
    <div class="profile profile-container profile-container--big">
      <h2 class="profile__name">{{ profile.origin.first_name }} {{ profile.origin.last_name }}</h2>
      <p class="profile__text-line">
        logged in as {{ profile.role }}
        @if (profile.organization_name) {
          at {{ profile.organization_name }}
        }
      </p>
      <p class="profile__text-line">{{ profile.first_name }} {{ profile.last_name }}</p>
      <p class="profile__text-line profile__email">{{ profile.email }}</p>
    </div>
  } @else {
    <div class="profile profile-container profile-container--big">
      <h2 class="profile__name">{{ profile.first_name }} {{ profile.last_name }}</h2>
      <p class="profile__text-line">
        {{ profile.role }}
        @if (profile.organization_name) {
          at {{ profile.organization_name }}
        }
      </p>
      <p class="profile__text-line profile__email">{{ profile.email }}</p>
      @if (isUserProfileLinkVisible) {
        <a class="cm-link" [routerLink]="profileLink" (click)="stopPropagation($event)">Profile details</a>
      }
    </div>
  }
</div>
<div class="possible-profiles">
  @for (possibleProfile of profiles; track possibleProfile.profile_id) {
    <a
      [routerLink]="getSwitchProfileLink | thunk: possibleProfile"
      (click)="stopPropagation($event)"
      class="possible-profiles__profile"
    >
      <cm-profile-avatar
        class="avatar avatar--small"
        [imageUrl]="possibleProfile.image"
        [placeholder]="possibleProfile.avatarPlaceholder"
      />
      <div class="profile profile-container profile-container--small">
        <h2 class="profile__name">{{ possibleProfile.first_name }} {{ possibleProfile.last_name }}</h2>
        <p class="profile__text-line">
          {{ possibleProfile.role }}
          @if (possibleProfile.organization_name) {
            at {{ possibleProfile.organization_name }}
          }
        </p>
        <p class="profile__text-line profile__email upcEm">{{ possibleProfile.email }}</p>
      </div>
    </a>
  }
</div>
